var exports = {
  "i": "x8b4e8595--6a92af--favorite-button",
  "s": "x8b4e8595--6a92af--icon-wrapper",
};

module.exports = exports;
